const Guarantee = () => (
  <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-b from-black to-gray-950 relative overflow-hidden">
    <div className="absolute inset-0 opacity-5 pointer-events-none">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-emerald-500 rounded-full blur-3xl"></div>
    </div>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
      <div className="max-w-4xl mx-auto text-center">
        <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-gradient-to-br from-emerald-500 to-teal-600 flex items-center justify-center mx-auto mb-6">
          <i className="ri-shield-check-line text-white text-4xl sm:text-5xl"></i>
        </div>
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 text-white">
          Satisfaction <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-400">Guaranteed or Refunded</span>
        </h2>
        <p className="text-lg sm:text-xl text-gray-400 mb-8 sm:mb-10 max-w-2xl mx-auto">
          Test our service for <b className="text-white">7 days</b>. If you are not satisfied, we will give you a full refund — no questions asked.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
          {[
            { icon: 'ri-money-cny-circle-line', title: '100% Refund', desc: 'Full refund if the service does not suit you' },
            { icon: 'ri-calendar-check-line', title: '7 Days to Test', desc: 'A full week to discover all features' },
            { icon: 'ri-customer-service-2-line', title: 'Dedicated Support', desc: 'Our team accompanies you throughout your trial' },
          ].map((item) => (
            <div key={item.title} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:border-emerald-500/50 transition-all">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-emerald-500/20 to-teal-500/20 flex items-center justify-center mx-auto mb-4">
                <i className={`${item.icon} text-emerald-400 text-2xl`}></i>
              </div>
              <h3 className="font-bold text-white mb-2">{item.title}</h3>
              <p className="text-sm text-gray-400">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Guarantee;
